import * as React from 'react';

import { translate } from '~l10n/client';
import { useAtom } from 'jotai';
import { RESET, atomWithReset } from 'jotai/utils';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation } from '~shared/components/Dialog';

const unableToDeleteAccountDialogAtom = atomWithReset<boolean>(false);
unableToDeleteAccountDialogAtom.onMount = (set) => {
  return () => {
    set(RESET);
  };
};

export function UnableToDeleteAccountDialog() {
  const [isOpen, setIsOpen] = useAtom(unableToDeleteAccountDialogAtom);

  const onClose = () => {
    setIsOpen(RESET);
  };

  return (
    <DialogConfirmation
      actions={[
        <UIButton key="ok" onClick={onClose}>
          {translate('OK')}
        </UIButton>,
      ]}
      open={isOpen}
      onClose={onClose}
      id={'unable-to-delete-account'}
      title={translate('Unable to Delete Account')}
    >
      {translate(
        'You must transfer ownership of your team(s) to another team member or remove all your members from your team.'
      )}
    </DialogConfirmation>
  );
}

UnableToDeleteAccountDialog.useIsOpen = () =>
  useAtom(unableToDeleteAccountDialogAtom);
